import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { RiFileCopyFill } from "react-icons/ri";
import { toast } from 'react-toastify';
import { AgentID } from "../services/agentServices";
import Loader from "../components/Loader";
import AgentOrderTable from "../components/tables/AgentOrderTable";

export const AgentDetails = ({ isOpen, onClose, id }) => {
  const [loading, setLoading] = useState(false);
  const [agentDetails, setAgentDetails] = useState(null);
  const [textToCopy, setTextToCopy] = useState(false);
  const phoneNumber = agentDetails?.phoneNumber


  const onCopyText = () => {
    setTextToCopy(true);
    toast.success("Copied!")
    setTimeout(() => setTextToCopy(false), 2000); 
  };

  useEffect(() => {
    const fetchAgentDetails = async () => {
        setLoading(true)
        try {
        const response = await AgentID(id);
        setAgentDetails(response?.data);
        } catch (error) {
        console.error("Error fetching Agent details:", error);
        toast.error("Failed to load Agent details.");
        } finally {
        setLoading(false);
        }
    }
    fetchAgentDetails();
  }, [id]);
 
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
    slotProps={{
      root: {
        className: `
          backdrop-blur-[1px] 
          bg-orange/20 
          rounded-tl-2xl 
        `,
      },
    }}  
    >
      <ModalClose />
      <div className="p-5">
        <h2 className="capitalize text-[22px] font-bold text-primaryRed mt-10">delivery agent profile and performance </h2>
        <p className="mb-6 mt-2 text-sm text-[#0A0A0A]/80">
            Review agent profile, track delivery stats, and monitor performance to maintain top service quality for customers.
        </p>
        { loading ?
          ( <Loader /> ) : (
        agentDetails && (
          <>
            <div className="flex items-center gap-2">
            {agentDetails.photo && (
              <img src={agentDetails?.photo} alt="" className="rounded-full h-[30px] h-[30px]" />
            )}
            <p className="text-lg font-semibold capitalize">agent profile information</p>          
            </div>
            <div className="mt-4 rounded-lg border px-3">
                <div className="flex justify-between items-center mt-3">
                  <p className="text-xs text-[#0A0A0A] opacity-80">Name</p>
                  <p className="text-xs font-medium capitalize">{agentDetails?.firstName}<span className='ml-1'>{agentDetails?.lastName}</span></p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className="flex justify-between items-center mt-3">
                  <p className="text-xs text-[#0A0A0A] opacity-80">identification number</p>
                  <p className="text-xs font-medium">{agentDetails?.identityNumber}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className="flex justify-between items-center mt-3">
                  <p className="text-xs text-[#0A0A0A] opacity-80">contact number</p>
                  <div className='flex items-center my-1'>
                    <p className="text-xs font-medium">{phoneNumber}</p>
                    <CopyToClipboard text={phoneNumber} onCopy={onCopyText}>
                      <RiFileCopyFill class="text-gray-400 ml-1 cursor-pointer" />
                    </CopyToClipboard>
                  </div>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className='flex items-center mt-3 justify-between'>
                  <p className="text-xs text-[#0A0A0A] opacity-80">Email</p>
                  <p className="text-xs font-medium">{agentDetails?.email}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                  <div className='flex items-center mt-3 justify-between'>
                  <p className="text-xs text-[#0A0A0A] opacity-80">Regions Covered</p>
                  <p className="text-xs font-medium pr-4 capitalize">{agentDetails?.regionCovered}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
            </div>
          </>
          ))}
        </div>
            <div className="h-[1px] w-full border-0 bg-primaryGray my-5" />
            <div className="p-5">
              <div className="flex items-center justify-between">
                <p className="text-[20px] text-[#0A0A0A] font-bold">Order History</p>
                <div className="flex items-center py-3 px-4 rounded-md bg-orange gap-2 mb-2">
                  <p className="text-xs text-center">Active Order</p>
                  <h2 className="flex items-center justify-center font-semibold text-xs mr-2 rounded-full text-center bg-white h-4 w-4"><span>{agentDetails?.agentMetrics?.activeOrder || "0"}</span></h2>
                </div>
              </div>
              <Box
                sx={{
                  paddingBottom: 2,
                  height: "auto",
                  display: "flex",
                  overflowX: "auto",
                  gap: 2,
                }}
              >
                <AgentOrderTable agentDetails={agentDetails} />
             </Box>
             <div className="h-[1px] w-full border-0 bg-primaryGray my-5" />
             <div className="mt-5">
              { loading ?
                ( <Loader /> ) : (
              agentDetails && (
                <>
                <p className="text-lg font-semibold capitalize">agent Bank Details</p>          
                  <div className="mt-2 rounded-lg border px-3">
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Bank Name</p>
                        <p className="text-xs font-medium capitalize">{agentDetails?.agentBanks?.bankName}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Account Name</p>
                        <p className="text-xs font-medium">{agentDetails?.agentBanks?.accountName}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                      <div className="flex justify-between items-center mt-3">
                        <p className="text-xs text-[#0A0A0A] opacity-80">Account Number</p>
                        <p className="text-xs font-medium">{agentDetails?.agentBanks?.accountNumber}</p>
                      </div>
                      <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                  </div>
                </>
                ))}
            </div>
             <h3 className="capitalize text-md font-semibold mt-4 mb-2">performance Overview</h3>
             <div className="py-3 px-4 rounded-md bg-orange">
                <div className="flex items-center justify-between">
                  <div className="">
                    <p className="text-sm text-center pb-6">Total Completed Order</p>
                    <h2 className="text-xs font-bold text-center">Average rating <span className="mr-3">{agentDetails?.agentMetrics?.averageRating}</span></h2>
                  </div>
                  <h1 className="text-5xl font-bold">{agentDetails?.agentMetrics?.countTotalCompleteOrder}</h1>
                </div>
              </div>
             <div className="py-3 px-4 rounded-md bg-[#4A90E2] text-white mt-3">
                <div className="flex items-center justify-between">
                  <div className="">
                    <p className="text-sm pb-6">Total Completed Order<br />
                      <span>This Month</span>
                    </p>
                    <h2 className="text-xs font-bold text-center bg-white text-blue-700 px-2 py-2 rounded-md">Total Order <span className="">{agentDetails?.agentMetrics?.countTotalCompleteOrderThisMonth}/{agentDetails?.agentMetrics?.countTotalAllOrderThisMonth}</span></h2>
                  </div>
                  <h1 className="text-5xl font-bold text-blue-700">{agentDetails?.agentMetrics?.countTotalAllOrderThisMonth}</h1>
                </div>
              </div>
        </div>
    </Drawer>
  )
}
